import { Component, OnInit, Input } from '@angular/core';
import { Globals } from '../objects/Globals';
import { JobService } from '../services/job.service';
import { Observable } from 'rxjs';
import { MainLoadingService } from '../services/main-loading.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-quick-links-panel',
  templateUrl: './quick-links-panel.component.html',
  styleUrls: ['./quick-links-panel.component.css']
})
export class QuickLinksPanelComponent implements OnInit {

  @Input() isEpic:boolean = false;
  @Input() hidePanel: boolean = false;

  valueSelection:any;
  selectedValue = 'Quick Links';
  private componentId:string;
  jobList: any;
  jobList$: Observable<string>;
  private availableImages = ['VIEWPR','CREATEPR', 'VIEWPO', 'CREATEPO', 'VIEWRFQ', 'CREATERFQ', 'VIEWSN', 'CREATESN', 'VIEWIV', 'CREATEIV', 'VIEWEBID', 'CREATEEBID', 'VIEWSUPPLIER', 'MANAGESUPPLIER', 'Template'];

  constructor(private globals: Globals, private jobService: JobService, private mainLoadingService: MainLoadingService, private router: Router) { }

  ngOnInit() {
    this.getJobList();
    this.valueSelection = [];
    this.valueSelection.push({ItemValue: "quick", ItemDisplay: "Quick Links"});
  }

  getJobList(){
    if(this.globals.Session){
      this.jobService.createJobList('dashboard').subscribe(result=>{
        this.componentId = result;
        this.refreshJobListCard();
      });
    }
  }

  refreshJobListCard(){
    if(this.componentId){
      this.jobService.getJobList(this.componentId).subscribe(result=>{
        this.jobList = JSON.parse(result);
      });
    }
  }

  triggerJob(jobId:string){
    if(jobId){
      this.mainLoadingService.setLoading(true);
      this.jobService.triggerJob(this.componentId, jobId).subscribe(result=> {
        var resultObject = JSON.parse(result);
        if(resultObject.ReturnType == "0"){
          if(resultObject.Arguments){
            var path = [];
            resultObject.Arguments.forEach(element => {
              path.push(element);
            });;
            this.router.navigate(path);
          }
        }
        this.mainLoadingService.setLoading(false);
      }, error => {
        this.mainLoadingService.setLoading(false);
      });
    }
  }
}
